/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

'use es6';

import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import MobilePanel from 'marketplace-ui-common/components/mobile/MobilePanel';
import MobilePanelBody from 'marketplace-ui-common/components/mobile/MobilePanelBody';
import MobileTypeaheadResults from 'marketplace-ui-common/components/mobile/MobileTypeaheadResults';
import MobileSearchBar from 'marketplace-ui-common/search/components/MobileSearchBar';
import { useStorefrontHeaderBackgroundStyles } from 'marketplace-ui-common/storefront/components/StorefrontHeader.utils';
import { debounce } from 'marketplace-ui-common/utils/debounce';
import globalNavHeight from 'nav-meta/global-nav-height';
import { useCallback, useContext, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import StorefrontUsageTrackerContext from '../context/StorefrontUsageTrackerContext';
import { SearchIcon } from 'foundations-assets/icons/components/SearchIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INNER_SEARCH_CLASS = 'inner-search-bar';
const StyledStickySearchBarWrapper = styled.div.withConfig({
  displayName: "MobileStorefrontHeader__StyledStickySearchBarWrapper"
})(() => {
  const theme = useTheme();
  const backgroundStyles = useStorefrontHeaderBackgroundStyles({
    color: 'teal'
  });
  return Object.assign({}, backgroundStyles, {
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    left: 0,
    width: '100%',
    height: globalNavHeight,
    padding: `${theme.space['100']} ${theme.space['200']}`
  });
});
const MobileStorefrontHeader = ({
  placeholder,
  searchTerm,
  onClearSearch,
  onSearchSubmit,
  loadOptions,
  onSelectedOptionChange
}) => {
  const {
    focusMobileFilterButton
  } = useContext(StorefrontUsageTrackerContext);
  const [mobileSearchBarFocused, setMobileSearchBarFocused] = useState(false);
  const [mobileTypeaheadOpen, setMobileTypeaheadOpen] = useState(false);
  const [mobileTypeaheadResults, setMobileTypeaheadResults] = useState([]);
  const [scrollPosition, setScrollPosition] = useState(0);
  const fetchTypeaheadResults = useCallback(searchValue => {
    loadOptions(searchValue.toLowerCase(), (__notUsedVar, {
      options
    }) => {
      setMobileTypeaheadResults(options);
    });
  }, [loadOptions]);
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
  const searchSubmit = useCallback(value => {
    setMobileTypeaheadOpen(false);
    setMobileTypeaheadResults([]);
    onSearchSubmit(value);
    focusMobileFilterButton();
  }, [onSearchSubmit]);
  const focusMobileSearchBar = useCallback(evt => {
    setMobileSearchBarFocused(true);
    setMobileTypeaheadOpen(true);
    if (evt.target.value && !mobileTypeaheadResults.length) {
      fetchTypeaheadResults(evt.target.value);
    }
  }, [fetchTypeaheadResults, mobileTypeaheadResults]);
  const cancelMobileSearch = useCallback(() => {
    setMobileSearchBarFocused(false);
    setMobileTypeaheadOpen(false);
    focusMobileFilterButton();
  }, []);
  const selectMobileTypeaheadItem = useCallback(item => {
    onClearSearch();
    setMobileSearchBarFocused(false);
    setMobileTypeaheadOpen(false);
    onSelectedOptionChange({
      target: {
        value: item
      }
    });
  }, [onClearSearch, onSelectedOptionChange]);
  const onSearchUpdate = useCallback(debounce(searchValue => {
    fetchTypeaheadResults(searchValue);
    setLocalSearchTerm(searchValue);
  }), [fetchTypeaheadResults]);
  const focusInnerSearchOnPanelOpen = useCallback(() => {
    const innerSearchBar = document.querySelector(`.${INNER_SEARCH_CLASS}`);
    if (innerSearchBar) {
      const innerSearchInput = innerSearchBar.querySelector('.mobile-search-input');
      if (innerSearchInput) {
        innerSearchInput.focus();
      }
    }
  }, []);
  const onPanelOpen = useCallback(() => {
    setScrollPosition(window.scrollY);
    window.onscroll = () => {
      window.scrollTo(0, 0);
    };
  }, []);
  const onPanelClose = useCallback(() => {
    window.onscroll = () => {};
    window.scrollTo(0, scrollPosition);
  }, [scrollPosition]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(TFlex, {
      justify: "end",
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: focusMobileSearchBar,
        use: "transparent",
        placement: "right",
        children: /*#__PURE__*/_jsx(SearchIcon, {
          color: "do-not-use-olaf"
        })
      })
    }), /*#__PURE__*/_jsx(MobilePanel, {
      onOpenStart: onPanelOpen,
      onOpenComplete: focusInnerSearchOnPanelOpen,
      onCloseStart: onPanelClose,
      open: mobileTypeaheadOpen,
      align: "top",
      children: /*#__PURE__*/_jsxs(MobilePanelBody, {
        children: [/*#__PURE__*/_jsx(StyledStickySearchBarWrapper, {
          children: /*#__PURE__*/_jsx(MobileSearchBar, {
            className: INNER_SEARCH_CLASS,
            cancelSearch: cancelMobileSearch,
            focused: mobileSearchBarFocused || mobileTypeaheadOpen,
            inputValue: localSearchTerm,
            onClear: onClearSearch,
            onSearchFocus: focusMobileSearchBar,
            onSearchSubmit: searchSubmit,
            onSearchUpdate: onSearchUpdate,
            placeholder: placeholder
          })
        }), /*#__PURE__*/_jsx(MobileTypeaheadResults, {
          options: mobileTypeaheadResults,
          onChange: selectMobileTypeaheadItem
        })]
      })
    })]
  });
};
export default MobileStorefrontHeader;